import { theme } from 'antd';

// The landing site's palette, so the dashboard and the login pages read as
// the same product. Shared by both; colours mirror the --d-* tokens in
// dashboard.css.
// The dark algorithm re-derives colorPrimary from the seed and darkens it
// (#7355F0 came out as #654BCF), so the buttons drifted off the brand violet
// the landing and the wordmark use. This step runs after it and puts the
// exact brand colour back, with hover/active shades that read on a dark ground
// (hover lighter, active deeper).
const BRAND = {
  colorPrimary: '#7355F0',
  colorPrimaryHover: '#8A70F3',
  colorPrimaryActive: '#5F43DB',
  colorPrimaryTextHover: '#B9A8FF',
  colorPrimaryText: '#9B83FF',
  colorPrimaryTextActive: '#8A70F3',
  colorPrimaryBorderHover: '#8A70F3',
  colorLink: '#9B83FF',
  colorLinkHover: '#B9A8FF',
  colorLinkActive: '#8A70F3'
};
const pinBrand = (seedToken, mapToken) => ({ ...mapToken, ...BRAND });

export const DARK_THEME = {
  algorithm: [theme.darkAlgorithm, pinBrand],
  token: {
    colorPrimary: '#7355F0',
    colorBgBase: '#0E0D14',
    colorBgContainer: '#1C1927',
    colorBgElevated: '#272233',
    colorBorder: 'rgba(242, 237, 227, 0.14)',
    colorBorderSecondary: 'rgba(242, 237, 227, 0.08)',
    colorText: '#F2EDE3',
    colorTextSecondary: 'rgba(242, 237, 227, 0.64)',
    colorSuccess: '#4FBF8B',
    colorWarning: '#E8865A',
    colorError: '#FF7A70',
    borderRadius: 8,
    fontSize: 14,
    // One control height everywhere (inputs, selects, buttons, segmented)
    // instead of mixing antd's 32px default with size="large"
    controlHeight: 36,
    fontFamily: 'Karla, Helvetica, Arial, sans-serif'
  },
  components: {
    Segmented: { itemSelectedBg: '#3a3150' }
  }
};
